/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

import { Button, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'

import styles from './error404Styles'

import { LogoSellerCenter, Error404Image } from 'components/icons/personalizedIcons'
import { routesLink } from 'constants/routesConsts'

const useStyles = makeStyles(styles)

export default function Error404() {
  const classes = useStyles()
  const history = useHistory()

  const handleClick = () => {
    history.push(routesLink.orders)
  }

  return (
    <Grid className={classes.container}>
      <LogoSellerCenter />

      <Error404Image />

      <Typography variant="subtitle1">¿Estás perdido?</Typography>
      <Typography className={classes.text} variant="body2">
        No encontramos lo que estabas buscando,
        <span className={classes.span}>¡Vuelve a intentarlo!</span>
      </Typography>

      <Button
        className={classes.btnBackgroundPrimary}
        color="secondary"
        variant="contained"
        onClick={handleClick}
      >
        Regresar a pedidos
      </Button>
    </Grid>
  )
}
